// SYNC(2) : 0xAA, 0x55 (고정)
// LENGTH(2) : 0x00, 0x07 (DEST~CHECK 길이)
// DEST_ID(1) : 0x0? (CELL LINE 값)
// COMMAND(2) : 0x02, 0x00 (고정 : DISPLAY CMD)
// SEQ_NUM(1) : 0x00 (고정 : 그래픽, 텍스트 (0x80))
// OFFSETT?(1) : 0x?? (cell 위치 지정)
// DATA(1) : N
// CHECK_SUM(1) : 계산

let reader;
export let dotpadState = null;
export let dotpadTTS = null;
export let dotpadwebCam = null;
export let dotpadStartListening = null;
export let dotpadStopListening = null;
export let dotpadButton3Hold = null;

import {DotpadSDK} from "./DotpadSDK.js";

// import {DotpadList} from "./DotpadList.js";
class Dotpad { // eslint-disable-line no-unused-vars
    dotPadSendModule = null;
    lastKeyPressed;
    // F3 키 롱프레스 감지
    btn3 = {
        isDown: false,
        downAt: 0,
        holdTimer: null,
        holdInterval: null,
    };
    // 직전 패킷에서의 FunctionKey 비트 상태 기억 (F3 감지용)
    _prevFunctionMask = 0; 
    _isRecognizing = false;

    constructor(deviceDialog) {
        this.HOLD_START_MS = 400;   // 홀드로 간주할 시작 지연 (ms)
        this.HOLD_REPEAT_MS = 200;  // 홀드 중 반복 알림 주기 (ms)
        this.deviceDialog = deviceDialog;
        this.device = null;
        this.onDisconnected = this.onDisconnected.bind(this);
        this.BLE_checked = true;
        this.connected = false;
        this.connectedDeviceName = "No device Connected";
        this.KeyInputCallbackFtn = null;
        this.disconnCallbackFtn = null;
        this.dotpadSDK = new DotpadSDK(this);
        this.characteristic = null; // bluetooth only
        this.lastKeyPressed = {name: null, keyPressTime: null, keyUpTime: null, pressedTime: null};
        this.responseHex = "";
        this.deviceInfo = {
            deviceName: null,
            firmwareVersion: null,
            hardwareVersion: null
        }
        this.deviceInfoFtn = null;
        this.functionKeyState = 0;
        this.functionKeyRelease = true;
        this.perkinsKeyState = 0;
        this.perkinsKeyRelease = true;
        this.edgethreshold = 150;
        this.currentPhotoUrl = null; 

        this.con_select = "";

        this.state  = "";
        this.tts  = "";
        this.webCam = false;
        this.startListening = false;
        this.stopListening = false;

    }

    async request() {
      const filters = [{usbVendorId: 1027, usbProductId: 24592}, {usbVendorId: 1027, usbProductId: 24597}];
        const serialPorts = await navigator.serial.getPorts();
        const matchedSerialPorts = serialPorts.filter(port => {
            const info = port.getInfo();

            return filters.some(filter => filter.usbVendorId === info.usbVendorId && filter.usbProductId === info.usbProductId);
        });

        // Bluetooth or USB 선택
        if (this.BLE_checked) {
            // Request access to Bluetooth devices
            if ('bluetooth' in navigator) {
                // Filter matched Serial Ports devices
                if (matchedSerialPorts.length > 0) {
                    // Serial port is connected
                    console.log('Serial port is connected');
                    // USB 케이블로 PC에 연결된 상태에서 닷 패드를 Bluetooth로 검색할 때, 아무런 블루투스 장비가 검색되지 않게 Dummy data 입력
                    await navigator.bluetooth.requestDevice({
                        filters: [{services: ['00001234-0000-1000-8000-00805f9b34fb']}]
                    });
                } else {
                    // Serial port is not connected
                    console.log('Serial port is not connected');
                    const bluetoothOption = {
                        "filters": [{
                            "namePrefix": "DotPad"
                        }],
                        "optionalServices": ["49535343-fe7d-4ae5-8fa9-9fafd205e455"]
                    };
                    this.device = await navigator.bluetooth.requestDevice(bluetoothOption);
                }
            } else {
                console.log('Web Bluetooth API is not supported in this browser');
            }
        } else {
            if ('serial' in navigator) {
                if(this.con_select == "COM"){
                    this.device = await navigator.serial.requestPort({filters: filters});
                } else {
                    
                    //00001101-0000-1000-8000-00805f9b34fb
                    this.device = await navigator.serial.requestPort({
                        allowedBluetoothServiceClassIds: ["00001101-0000-1000-8000-00805f9b34fb"],
                        filters: [{ bluetoothServiceClassId: "00001101-0000-1000-8000-00805f9b34fb" }],
                      });
                }
            } else {
                console.log('Web Serial API is not supported in this browser');
            }
        }

        if (!this.device)
            throw "No device selected";

        if (this.BLE_checked)
            this.device.addEventListener('gattserverdisconnected', this.onDisconnected, {once: true});
        else
            this.device.addEventListener('disconnect', this.disconnect.bind(this), {once: true});
    }

    async connect() {
        if (!this.device)
            return Promise.reject('Cannot connect to device. No device selected.');

        //BLE or USB 선택
        if (this.BLE_checked) {
            let retryCount = 0;
            while (retryCount < 3) {
                try {
                    // console.log('connect() : ' + this.device);
                    const server = await this.device.gatt.connect();
                    const service = await this.device.gatt.getPrimaryService("49535343-fe7d-4ae5-8fa9-9fafd205e455");
                    this.characteristic = await service.getCharacteristic("49535343-1e4d-4bd9-ba61-23c647249616");
                    this.characteristic.startNotifications()
                        .then(() => {
                            console.log('> Notifications started');
                            return this.characteristic.addEventListener('characteristicvaluechanged', this.handleNotifications.bind(this));
                        })
                        .then(this.getDeviceInfo.bind(this));
                    this.connected = true;
                    this.connectedDeviceName = server.device.name;
                    break;
                } catch (error) {
                    // 에러 처리
                    console.error(`Connection attempt ${retryCount + 1} failed: ${error.message}`);
                    retryCount++;
                }
            }
        } else {
            try {
                await this.device.open({baudRate: 115200, dataBits: 8});
                const {usbProductId, usbVendorId} = await this.device.getInfo();
                const handleReadData = this.getHandleReadData()
                // Listen for the event.
                this.device.addEventListener("change", handleReadData);
                // Dispatch the event.
                this.device.dispatchEvent(new CustomEvent("change"));
                this.getDeviceInfo();
                this.connected = true;
                if (this.con_select == "BT SPP"){
                    this.connectedDeviceName = "connecting";
                    this.showSpinner();
                } else {
                    this.connectedDeviceName = usbProductId + " : " + usbVendorId + " connected";
                }
            } catch (e) {
                console.log(e.toString())
                this.connected = false;
                this.connectedDeviceName = "No device Connected";
            }
        }
    }

    // 시리얼포트 전용 커스텀 이벤트
    async getHandleReadData() {
        reader = this.device.readable.getReader();
        try {
            // eslint-disable-next-line no-constant-condition
            while (true) {
                const {value, done} = await reader.read();

                if (done) {
                    // |reader| has been canceled.
                    break;
                }
                // Do something with |value|…
                this.handleNotifications(value);
            }
        } catch (error) {
            // Handle |error|…
        } finally {
            reader.releaseLock();
        }
    }

    handleNotifications(event) {
        const keyEventMap = {
            PERKINS_KEY: "aa55000900031200",
            FUNCTION_KEY: "aa55000900033200",
        };
        const deviceInfoMap = {
            RSP_FW_VER: /aa55000d00000100.*/,
            RSP_HW_VERSION: /aa55000600001100.*/,
            RSP_DEV_NAME: /aa55(....)00010100.*/,
        };
        const ackPattern = /aa550006(..)0201(..)00.*/;
        const notiPattern = /aa550006(..)0202(..)00.*/;
        const value = event instanceof Event ? event.target.value : event;
        // Convert raw data bytes to hex string
        let hexStr = Array.from(new Uint8Array(value.buffer))
            .map(b => b.toString(16).padStart(2, '0'))
            .join('');

        if (this.responseHex.length + hexStr.length < 18) {
            this.responseHex = `${this.responseHex}${hexStr}`;
            hexStr = "";
        } else {
            hexStr = `${this.responseHex}${hexStr}`;
            this.responseHex = "";
        }

        const packetArray = this.extractPackets(hexStr);

        for (let packet of packetArray) {
            if (this.isKeyEventPacket(keyEventMap, packet)) {
                this.processKeyEvent(keyEventMap, packet);
            } else if (this.isDeviceInfoPacket(deviceInfoMap, packet)) {
                this.processDeviceInfo(deviceInfoMap, packet);
            } else if (packet.startsWith('abcdef')) { // Check for disconnected event
                console.log('Device disconnected');
                this.device.disconnect();
            }

            const ackPacket = this.isAckPacket(ackPattern, packet);
            if (ackPacket) {
                this.handleAckPacket(ackPacket);
            }

            // USB일 경우 NOTI 체크
            if (!this.BLE_checked) {
                const notiPacket = this.isAckPacket(notiPattern, packet);
                if (notiPacket) {
                    if (this.dotPadSendModule) {
                        this.dotPadSendModule.setDotCommandSendReady(true);
                    }
                }
            }
        }
    }

    _dispatch(name, detail) {
        window.dispatchEvent(new CustomEvent(name, { detail }));
    }

    _clearBtn3Timers() {
        if (this.btn3.holdTimer) {
            clearTimeout(this.btn3.holdTimer);
            this.btn3.holdTimer = null;
        }
        if (this.btn3.holdInterval) {
            clearInterval(this.btn3.holdInterval);
            this.btn3.holdInterval = null;
        }
    }


    isKeyEventPacket(keyEventMap, packet) {
        return Object.values(keyEventMap).some(keyEventPattern => packet.startsWith(keyEventPattern));
    }

    processKeyEvent(keyEventMap, packet) {
        const keyEvent = Object.keys(keyEventMap).find(type => packet.match(keyEventMap[type]));

        if (keyEvent) {
            if (keyEvent === "PERKINS_KEY") {
                const perkinsKeyData = parseInt(packet.substr(19, 1), 16);

                if (this.perkinsKeyRelease) {
                    this.perkinsKeyRelease = false;
                    this.lastKeyPressed.keyPressTime = new Date();
                }

                if (this.perkinsKeyState < perkinsKeyData) {
                    this.perkinsKeyState = perkinsKeyData;
                } else if (perkinsKeyData === 0) {
                    this.perkinsKeyRelease = true;
                    this.lastKeyPressed.keyUpTime = new Date();
                }
            } else if (keyEvent === "FUNCTION_KEY") {
                const functionKeyData = parseInt(packet.substr(16, 1), 16);

                if (this.functionKeyRelease) {
                    this.functionKeyRelease = false;
                    this.lastKeyPressed.keyPressTime = new Date();
                }

                if (this.functionKeyState < functionKeyData) {
                    this.functionKeyState = functionKeyData;
                } else if (functionKeyData === 0) {
                    this.functionKeyRelease = true;
                    this.lastKeyPressed.keyUpTime = new Date();
                }
                // ▼▼▼ F3 상태머신 (패킷 기반) ▼▼▼
                    const F3_MASK = 0x02;
                    // const functionKeyData = this.functionKeyState; // 이미 계산된 값 사용
                    const hasF3 = (functionKeyData & F3_MASK) === F3_MASK;
                    const prevHasF3 = (this._prevFunctionMask & F3_MASK) === F3_MASK;

                    // Down: 이전엔 X, 지금은 O
                    if (!prevHasF3 && hasF3) {
                        this.btn3.isDown = true;
                        this.btn3.downAt = Date.now();
                        console.log("button3 down....");

                        // 음성인식 시작 (한 번만)
                        if (!this._isRecognizing) {
                        this._isRecognizing = true;
                        this.startListening = true;
                        this._dispatch('dotpad-start-listening', { at: this.btn3.downAt });
                        this.startListening = false; // 즉시 플래그 리셋 (한 번만 쏘기)
                        }

                        // (선택) 홀드 타이머: 일정시간 유지되면 hold 이벤트 시작
                        this._clearBtn3Timers();
                        this.btn3.holdTimer = setTimeout(() => {
                        this._dispatch('dotpad-button3-hold', { since: this.btn3.downAt });
                        this.btn3.holdInterval = setInterval(() => {
                            this._dispatch('dotpad-button3-hold', { since: this.btn3.downAt });
                            console.log("button3 hold...");
                        }, this.HOLD_REPEAT_MS);
                        }, this.HOLD_START_MS);
                    }

                    // Up: 이전엔 O, 지금은 X
                    if (prevHasF3 && !hasF3) {
                        const upAt = Date.now();
                        console
                        const duration = upAt - (this.btn3.downAt || upAt);
                        this._clearBtn3Timers();

                        if (this.btn3.isDown) {
                        // 음성인식 중지 + 웹캠 온
                        this.stopListening = true;
                        console.log("stop listening true...");
                        this.webCam = true;

                        this._dispatch('dotpad-stop-listening', { at: upAt, durationMs: duration });
                        this._dispatch('dotpad-webCam-changed', { webCam: true });

                        // 플래그 리셋
                        this.stopListening = false;
                        this.webCam = false;
                        this._isRecognizing = false;
                        this.btn3.isDown = false;
                        this.btn3.downAt = 0;
                        console.log("button3 up....");
                        }
                    }

                    // 다음 루프 대비
                    this._prevFunctionMask = functionKeyData;
                    // ▲▲▲ F3 상태머신 끝 ▲▲▲
            }

            if (this.perkinsKeyRelease || this.functionKeyRelease) {
                if (this.lastKeyPressed.keyPressTime && this.lastKeyPressed.keyUpTime) {
                    this.lastKeyPressed.pressedTime =
                    this.lastKeyPressed.keyUpTime.getTime() - this.lastKeyPressed.keyPressTime.getTime();
                }
                // if (this.perkinsKeyState === 6) {
                //     if (this.functionKeyState === 0) {
                //         this.lastKeyPressed.name = "Left Pan + Right Pan";
                //     }
                // } else if (this.perkinsKeyState === 4) {
                //     if (this.functionKeyState === 8) {
                //         this.lastKeyPressed.name = "Left Pan + Function 1";
                //     } else if (this.functionKeyState === 0) {
                //         this.lastKeyPressed.name = "Left Pan";
                //     }
                // } else if (this.perkinsKeyState === 2) {
                //     if (this.functionKeyState === 1) {
                //         this.lastKeyPressed.name = "Function 4 + Right Pan";
                //     } else if (this.functionKeyState === 0) {
                //         this.lastKeyPressed.name = "Right Pan";
                //     }
                // } else if (this.perkinsKeyState === 0) {
                //     const functionKeyNameMap = {
                //         12: "Function 1 + Function 2",
                //         8: "Function 1",
                //         6: "Function 2 + Function 3",
                //         4: "Function 2",
                //         3: "Function 3 + Function 4",
                //         2: "Function 3",
                //         1: "Function 4"
                //     };
                //     this.lastKeyPressed.name = functionKeyNameMap[this.functionKeyState];
                // }

    
                // if (this.functionKeyState === 8) {
                //     console.log('button1 pressed...');
                //     this.state  = "1"
                // } else if (this.functionKeyState === 4) {
                //     console.log('button2 pressed....');
                //     this.state  = "2"
                // } else if (this.functionKeyState === 2) {
                //     console.log('button3 pressed....');
                //     this.state  = "3"
                // } else if (this.functionKeyState === 1) {
                //     console.log('button4 pressed....');
                //     this.tts = "0"
                // } 
                
                // if (this.perkinsKeyState === 4) {
                //     console.log('left pressed....');
                //     this.tts = "0"
                // } else if (this.perkinsKeyState === 2) {
                //     console.log('right pressed....');
                //     this.tts = "0"
                // }            
                if (this.perkinsKeyState === 4) {
                    console.log("Left Pan pressed (←)");
                    this.tts = "L";
        
                } else if (this.perkinsKeyState === 2) {
                    console.log("Right Pan pressed (→)");
                    this.tts = "R";
                 
                } else if (this.perkinsKeyState === 6) {
                    console.log("Both Pans pressed (←→)");
        
                } else {
                    // 여기서는 Perkins 안 눌렀으니 Function 키만 판정
                    const functionKeyNameMap = {
                    12: "Function 1 + Function 2",
                    8:  "Function 1",
                    6:  "Function 2 + Function 3",
                    4:  "Function 2",
                    3:  "Function 3 + Function 4",
                    2:  "Function 3",
                    1:  "Function 4"
                    };
                    this.lastKeyPressed.name = functionKeyNameMap[this.functionKeyState];

                    if (this.functionKeyState === 8) {
                    console.log("button1 pressed...");
                    this.state = "1";
                    } else if (this.functionKeyState === 4) {
                    console.log("button2 pressed...");
                    this.state = "2";
                    } else if (this.functionKeyState === 2) {
                    console.log("button3 pressed...");
                    // this.webCam = true;
                    

                    // this.startListening=true; // 음성 인식 시작

                    // // 버튼에서 손을 뗐을 때 이벤트 처리
                    // document.addEventListener('keyup', (event) => {
                    //     console.log("button3 released...");
                    //     this.stopListening=true; // 음성 인식 중지
                    //     this.webCam = true;
                        
                    // }, { once: true }); // 한 번만 실행되도록 설정
                    } else if (this.functionKeyState === 1) {
                    console.log("button4 pressed...");
                    this.tts = "S";
        
                    }
                }
        


                if (this.state) {
                    console.log("this.state", this.state)
                window.dispatchEvent(
                    new CustomEvent('dotpad-state-changed', {
                    detail: { state: this.state}
                    })
                );
                }

                // 2) tts 이벤트: 매번 쏘기
                if (this.tts) {
                window.dispatchEvent(
                    new CustomEvent('dotpad-TTS-changed', {
                    detail: { tts: this.tts}
                    })
                );
                }

                if (this.webCam) {
                    window.dispatchEvent(
                        new CustomEvent('dotpad-webCam-changed', {
                        detail: { webCam: this.webCam}
                        })
                    );
                }


                if (this.startListening){
                    window.dispatchEvent(
                        new CustomEvent('dotpad-start-listening', {
                                detail: { startListening: this.startListening }
                            })
                    )
                }

                if (this.stopListening){
                    window.dispatchEvent(
                        new CustomEvent('dotpad-stop-listening', {
                                detail: { stopListening: this.stopListening }
                            })
                    );
                }

                if(this.btn3.downAt){
                    window.dispatchEvent(
                        new CustomEvent('dotpad-button3-hold', {
                                detail: { since: this.btn3.downAt }
                            })
                    );
                }

            

                // 기존 초기화는 그대로 유지
                this.perkinsKeyState   = 0;
                this.functionKeyState  = 0;
                this.perkinsKeyRelease = false;
                this.functionKeyRelease= false;
                this.state = "";
                this.tts   = "";
                this.webCam = false;
            }
        }
    }

    isDeviceInfoPacket(deviceInfoMap, packet) {
        return Object.values(deviceInfoMap).some(deviceInfoPattern => packet.match(deviceInfoPattern));
    }

    processDeviceInfo(deviceInfoMap, packet) {
        const deviceInfo = Object.keys(deviceInfoMap).find(type => packet.match(deviceInfoMap[type]));

        if (deviceInfo) {
            const lastIndex = 16;
            const deviceResponseData = packet.substring(lastIndex, packet.length - 2);
            const deviceResponseAscii = this.hexToAscii(deviceResponseData);
            switch (deviceInfo) {
                case 'RSP_FW_VER':
                    this.deviceInfo.firmwareVersion = deviceResponseAscii;
                    break;
                case 'RSP_HW_VERSION':
                    this.deviceInfo.hardwareVersion = deviceResponseAscii;
                    break;
                case 'RSP_DEV_NAME':
                    this.deviceInfo.deviceName = deviceResponseAscii;
                    break;
            }

            if (this.deviceInfoFtn != null) {
                this.deviceInfoFtn();
            }
        }
    }

    isAckPacket(ackPattern, packet) {
        return packet.match(ackPattern);
    }

    handleAckPacket(ackPacket) {
        const ackValue = parseInt(ackPacket[1], 16);

        if (this.dotPadSendModule) {
            this.dotPadSendModule.setDotPadLineReceiveAck(ackValue, true);
            this.dotPadSendModule.setDotCommandSendReady(true);
            // BLE일 경우 NOTI 체크안함
            if (this.BLE_checked) {
                this.dotPadSendModule.setDotCommandSendReady(true);
            }
        }
    }

    extractPackets(packetHexString) {
        let packets = [];
        let currentIndex = 0;

        while (currentIndex < packetHexString.length) {
            if (packetHexString.length - currentIndex < 18) {
                // 패킷의 길이가 12보다 작을 경우 남은 데이터는 패킷이 아님
                this.responseHex = packetHexString.substring(currentIndex);
                break;
            }

            const startIndex = currentIndex + 4;
            const endIndex = startIndex + 4;
            const lengthHex = packetHexString.substring(startIndex, endIndex);

            const length = parseInt(lengthHex, 16);
            if (isNaN(length)) {
                // 길이를 16진수에서 10진수로 변환할 수 없음
                this.responseHex = packetHexString.substring(currentIndex);
                break;
            }

            const packetStartIndex = currentIndex + 8;
            const packetEndIndex = packetStartIndex + length * 2;
            const packet = packetHexString.substring(currentIndex, packetEndIndex);

            if(packet.length === length * 2 + 8){
                packets.push(packet);
                currentIndex = packetEndIndex;
            } else {
                this.responseHex = packetHexString.substring(currentIndex);
                break;
            }
        }

        return packets;
    }

    printDTM(pinData) {
        for (let i = 0; i < 20; i++) {
            console.log('printDTM : ' + pinData[i]);
        }
    }

    async writeCmdTest(cmdCode) {
        try {
            if (this.BLE_checked) {
                await this.characteristic.writeValueWithoutResponse(cmdCode);
                return true;
            } else {
                const writer = this.device.writable.getWriter();
                await writer.write(cmdCode);
                writer.releaseLock();
                return true;
            }
        } catch (e) {
            console.error(e);
        }
    }

    disconnect() {
        this._clearBtn3Timers();
        this._isRecognizing = false;
        if (!this.device) {
            return Promise.reject('Device is not connected.');
        }

        if (this.BLE_checked) {
            return this.device.gatt.disconnect();
        } else {
            if (reader) {
                return reader.cancel()
                    .catch(() => console.error('Could not ReadableStream cancel.'))
                    .then(() => reader = null)
                    .then(() => this.device.close())
                    .then(() => this.onDisconnected())
                    .catch((error) => console.error(error));
            }
        }
    }

    onDisconnected() {
        console.log('Device is disconnected.');
        this.disconnCallbackFtn(this.connectedDeviceName);
    }

    setDotPadSendModule(dotPadSendModule) {
        this.dotPadSendModule = dotPadSendModule;
    }

    async getDeviceName() {
        this.deviceInfoFtn = this.getFirmwareVersion;
        const hexToBytes = `${"00"}${"0100"}${"00"}`;

        await this.sendDeviceInfoCommand(hexToBytes);
    }

    async getFirmwareVersion() {
        this.deviceInfoFtn = this.getHardwareVersion;
        const hexToBytes = `${"00"}${"0000"}${"00"}`;

        await this.sendDeviceInfoCommand(hexToBytes);
    }

    async getHardwareVersion() {
        this.deviceInfoFtn = null;
        const hexToBytes = `${"00"}${"0010"}${"00"}`;

        await this.sendDeviceInfoCommand(hexToBytes);
    }

    async sendDeviceInfoCommand(hexToBytes) {
        const dot_protocol_header = `${"AA55"}${"0005"}`;
        const checksum = this.dotpadSDK.checksum(hexToBytes);
        const hexStringToArrayBuffer = this.dotpadSDK.hexStringToArrayBuffer(`${dot_protocol_header}${hexToBytes}${checksum}`);

        await this.writeCmdTest(hexStringToArrayBuffer);
    }

    getDeviceInfo() {
        this.getDeviceName()
            .then(() => new Promise(resolve => setTimeout(resolve, 2000))) // Delay for 2 second
            // Disconnect if no device is connected.
            .then(() => {
                console.log(this.deviceInfo);
                if (this.deviceInfo.deviceName === null || this.deviceInfo.deviceName === undefined) {
                    this.disconnect();
                } else if (this.con_select == "BT SPP") {
                    this.connectedDeviceName = this.deviceInfo.deviceName + " connected";
                    this.deviceDialog.reloadDeviceList();
                    this.hideSpinner();
                }
            });
    }

    hexToAscii(hex) {
        let ascii = '';
        for (let i = 0; i < hex.length; i += 2) {
            const hexByte = hex.substr(i, 2);
            const decimalValue = parseInt(hexByte, 16);
            ascii += String.fromCharCode(decimalValue);
        }
        return ascii;
    }
    showSpinner() {
        document.getElementById("spinner").classList.remove('d-none');
    }

    hideSpinner() {
        document.getElementById("spinner").classList.add('d-none');
    }
}

export {
    Dotpad
}
